export default __webpack_public_path__ + "static/macOS-6e65fe62295ed19e92ee02a1ce997665.webp";